import { default as cancel_45contractTRFz788AbgMeta } from "/home/forge/app.getgreengold.com/pages/cancel-contract.vue?macro=true";
import { default as indexDRqiQ1wmBQMeta } from "/home/forge/app.getgreengold.com/pages/cash-balance/index.vue?macro=true";
import { default as indexzWlXYTS0wKMeta } from "/home/forge/app.getgreengold.com/pages/cash-balance/top-up/index.vue?macro=true";
import { default as indexrNTtlUUXX7Meta } from "/home/forge/app.getgreengold.com/pages/cash-balance/withdraw/index.vue?macro=true";
import { default as dashboardUrO9X3q9kKMeta } from "/home/forge/app.getgreengold.com/pages/dashboard.vue?macro=true";
import { default as _91type_93YbPz4DhbD7Meta } from "/home/forge/app.getgreengold.com/pages/depot/[type].vue?macro=true";
import { default as _91id_93HR4execf2IMeta } from "/home/forge/app.getgreengold.com/pages/depot/addsavingplan/[id].vue?macro=true";
import { default as _91id_93OKKhEdAlyhMeta } from "/home/forge/app.getgreengold.com/pages/depot/detail/[id].vue?macro=true";
import { default as _91type_93R9ll6Vxy6oMeta } from "/home/forge/app.getgreengold.com/pages/depot/new/[type].vue?macro=true";
import { default as indexIgEusYBR7BMeta } from "/home/forge/app.getgreengold.com/pages/etf-transaction-history/index.vue?macro=true";
import { default as indexToqKYMH7KuMeta } from "/home/forge/app.getgreengold.com/pages/inbox-message/index.vue?macro=true";
import { default as indexPfzQq59IOhMeta } from "/home/forge/app.getgreengold.com/pages/index.vue?macro=true";
import { default as _91_91isin_93_93cb9fCgkinBMeta } from "/home/forge/app.getgreengold.com/pages/instruments/buy/[[isin]].vue?macro=true";
import { default as _91isin_93c4OBt9LWd4Meta } from "/home/forge/app.getgreengold.com/pages/instruments/details/[isin].vue?macro=true";
import { default as index_oldIcWNrzpazrMeta } from "/home/forge/app.getgreengold.com/pages/instruments/index_old.vue?macro=true";
import { default as indexHqyoBoVvi9Meta } from "/home/forge/app.getgreengold.com/pages/instruments/index.vue?macro=true";
import { default as indexOVtT4de8uJMeta } from "/home/forge/app.getgreengold.com/pages/instruments/list/index.vue?macro=true";
import { default as _91_91isin_93_93LJARvkTcRhMeta } from "/home/forge/app.getgreengold.com/pages/instruments/savings-plan/add/[[isin]].vue?macro=true";
import { default as _91_91isin_93_932Gh8YSXTNaMeta } from "/home/forge/app.getgreengold.com/pages/instruments/sell/[[isin]].vue?macro=true";
import { default as indexYugK3oK2vRMeta } from "/home/forge/app.getgreengold.com/pages/instruments/tax-exemption/index.vue?macro=true";
import { default as loginUBy2MqfbiQMeta } from "/home/forge/app.getgreengold.com/pages/login.vue?macro=true";
import { default as index73UzsvxM2KMeta } from "/home/forge/app.getgreengold.com/pages/profile/index.vue?macro=true";
import { default as verifyRDpRXGVuOCMeta } from "/home/forge/app.getgreengold.com/pages/profile/verify.vue?macro=true";
import { default as registerkgNhNitoBZMeta } from "/home/forge/app.getgreengold.com/pages/register.vue?macro=true";
import { default as request_45passwordb10KC7EvUoMeta } from "/home/forge/app.getgreengold.com/pages/request-password.vue?macro=true";
import { default as reset_45passwordJAZDhGxgvMMeta } from "/home/forge/app.getgreengold.com/pages/reset-password.vue?macro=true";
import { default as reset_45pinUHLTOflYeTMeta } from "/home/forge/app.getgreengold.com/pages/reset-pin.vue?macro=true";
import { default as indexvFVU1daJV8Meta } from "/home/forge/app.getgreengold.com/pages/security-legal-document/index.vue?macro=true";
import { default as simulatorkt2BxS51gOMeta } from "/home/forge/app.getgreengold.com/pages/simulator.vue?macro=true";
import { default as indexijbq3UOengMeta } from "/home/forge/app.getgreengold.com/pages/support-tickets/index.vue?macro=true";
import { default as _91_91depotid_93_93HakVe2VTZHMeta } from "/home/forge/app.getgreengold.com/pages/trading/buy/[[depotid]].vue?macro=true";
import { default as _91_91depotid_93_93pXhJQXF6zyMeta } from "/home/forge/app.getgreengold.com/pages/trading/delivery/[[depotid]].vue?macro=true";
import { default as _91_91depotid_93_936rmo02NVtTMeta } from "/home/forge/app.getgreengold.com/pages/trading/sell/[[depotid]].vue?macro=true";
import { default as _91_91depotid_93_93GuSj10qM0eMeta } from "/home/forge/app.getgreengold.com/pages/trading/transfer/[[depotid]].vue?macro=true";
import { default as indexQ3Ema4vgzPMeta } from "/home/forge/app.getgreengold.com/pages/upvest-account-history/index.vue?macro=true";
import { default as indexKHN78DaWjwMeta } from "/home/forge/app.getgreengold.com/pages/upvest-activate/index.vue?macro=true";
export default [
  {
    name: cancel_45contractTRFz788AbgMeta?.name ?? "cancel-contract___de",
    path: cancel_45contractTRFz788AbgMeta?.path ?? "/de/cancel-contract",
    meta: cancel_45contractTRFz788AbgMeta || {},
    alias: cancel_45contractTRFz788AbgMeta?.alias || [],
    redirect: cancel_45contractTRFz788AbgMeta?.redirect,
    component: () => import("/home/forge/app.getgreengold.com/pages/cancel-contract.vue").then(m => m.default || m)
  },
  {
    name: cancel_45contractTRFz788AbgMeta?.name ?? "cancel-contract___en",
    path: cancel_45contractTRFz788AbgMeta?.path ?? "/en/cancel-contract",
    meta: cancel_45contractTRFz788AbgMeta || {},
    alias: cancel_45contractTRFz788AbgMeta?.alias || [],
    redirect: cancel_45contractTRFz788AbgMeta?.redirect,
    component: () => import("/home/forge/app.getgreengold.com/pages/cancel-contract.vue").then(m => m.default || m)
  },
  {
    name: cancel_45contractTRFz788AbgMeta?.name ?? "cancel-contract___fr",
    path: cancel_45contractTRFz788AbgMeta?.path ?? "/fr/cancel-contract",
    meta: cancel_45contractTRFz788AbgMeta || {},
    alias: cancel_45contractTRFz788AbgMeta?.alias || [],
    redirect: cancel_45contractTRFz788AbgMeta?.redirect,
    component: () => import("/home/forge/app.getgreengold.com/pages/cancel-contract.vue").then(m => m.default || m)
  },
  {
    name: cancel_45contractTRFz788AbgMeta?.name ?? "cancel-contract___nl",
    path: cancel_45contractTRFz788AbgMeta?.path ?? "/nl/cancel-contract",
    meta: cancel_45contractTRFz788AbgMeta || {},
    alias: cancel_45contractTRFz788AbgMeta?.alias || [],
    redirect: cancel_45contractTRFz788AbgMeta?.redirect,
    component: () => import("/home/forge/app.getgreengold.com/pages/cancel-contract.vue").then(m => m.default || m)
  },
  {
    name: indexDRqiQ1wmBQMeta?.name ?? "cash-balance___de",
    path: indexDRqiQ1wmBQMeta?.path ?? "/de/cash-balance",
    meta: indexDRqiQ1wmBQMeta || {},
    alias: indexDRqiQ1wmBQMeta?.alias || [],
    redirect: indexDRqiQ1wmBQMeta?.redirect,
    component: () => import("/home/forge/app.getgreengold.com/pages/cash-balance/index.vue").then(m => m.default || m)
  },
  {
    name: indexDRqiQ1wmBQMeta?.name ?? "cash-balance___en",
    path: indexDRqiQ1wmBQMeta?.path ?? "/en/cash-balance",
    meta: indexDRqiQ1wmBQMeta || {},
    alias: indexDRqiQ1wmBQMeta?.alias || [],
    redirect: indexDRqiQ1wmBQMeta?.redirect,
    component: () => import("/home/forge/app.getgreengold.com/pages/cash-balance/index.vue").then(m => m.default || m)
  },
  {
    name: indexDRqiQ1wmBQMeta?.name ?? "cash-balance___fr",
    path: indexDRqiQ1wmBQMeta?.path ?? "/fr/cash-balance",
    meta: indexDRqiQ1wmBQMeta || {},
    alias: indexDRqiQ1wmBQMeta?.alias || [],
    redirect: indexDRqiQ1wmBQMeta?.redirect,
    component: () => import("/home/forge/app.getgreengold.com/pages/cash-balance/index.vue").then(m => m.default || m)
  },
  {
    name: indexDRqiQ1wmBQMeta?.name ?? "cash-balance___nl",
    path: indexDRqiQ1wmBQMeta?.path ?? "/nl/cash-balance",
    meta: indexDRqiQ1wmBQMeta || {},
    alias: indexDRqiQ1wmBQMeta?.alias || [],
    redirect: indexDRqiQ1wmBQMeta?.redirect,
    component: () => import("/home/forge/app.getgreengold.com/pages/cash-balance/index.vue").then(m => m.default || m)
  },
  {
    name: indexzWlXYTS0wKMeta?.name ?? "cash-balance-top-up___de",
    path: indexzWlXYTS0wKMeta?.path ?? "/de/cash-balance/top-up",
    meta: indexzWlXYTS0wKMeta || {},
    alias: indexzWlXYTS0wKMeta?.alias || [],
    redirect: indexzWlXYTS0wKMeta?.redirect,
    component: () => import("/home/forge/app.getgreengold.com/pages/cash-balance/top-up/index.vue").then(m => m.default || m)
  },
  {
    name: indexzWlXYTS0wKMeta?.name ?? "cash-balance-top-up___en",
    path: indexzWlXYTS0wKMeta?.path ?? "/en/cash-balance/top-up",
    meta: indexzWlXYTS0wKMeta || {},
    alias: indexzWlXYTS0wKMeta?.alias || [],
    redirect: indexzWlXYTS0wKMeta?.redirect,
    component: () => import("/home/forge/app.getgreengold.com/pages/cash-balance/top-up/index.vue").then(m => m.default || m)
  },
  {
    name: indexzWlXYTS0wKMeta?.name ?? "cash-balance-top-up___fr",
    path: indexzWlXYTS0wKMeta?.path ?? "/fr/cash-balance/top-up",
    meta: indexzWlXYTS0wKMeta || {},
    alias: indexzWlXYTS0wKMeta?.alias || [],
    redirect: indexzWlXYTS0wKMeta?.redirect,
    component: () => import("/home/forge/app.getgreengold.com/pages/cash-balance/top-up/index.vue").then(m => m.default || m)
  },
  {
    name: indexzWlXYTS0wKMeta?.name ?? "cash-balance-top-up___nl",
    path: indexzWlXYTS0wKMeta?.path ?? "/nl/cash-balance/top-up",
    meta: indexzWlXYTS0wKMeta || {},
    alias: indexzWlXYTS0wKMeta?.alias || [],
    redirect: indexzWlXYTS0wKMeta?.redirect,
    component: () => import("/home/forge/app.getgreengold.com/pages/cash-balance/top-up/index.vue").then(m => m.default || m)
  },
  {
    name: indexrNTtlUUXX7Meta?.name ?? "cash-balance-withdraw___de",
    path: indexrNTtlUUXX7Meta?.path ?? "/de/cash-balance/withdraw",
    meta: indexrNTtlUUXX7Meta || {},
    alias: indexrNTtlUUXX7Meta?.alias || [],
    redirect: indexrNTtlUUXX7Meta?.redirect,
    component: () => import("/home/forge/app.getgreengold.com/pages/cash-balance/withdraw/index.vue").then(m => m.default || m)
  },
  {
    name: indexrNTtlUUXX7Meta?.name ?? "cash-balance-withdraw___en",
    path: indexrNTtlUUXX7Meta?.path ?? "/en/cash-balance/withdraw",
    meta: indexrNTtlUUXX7Meta || {},
    alias: indexrNTtlUUXX7Meta?.alias || [],
    redirect: indexrNTtlUUXX7Meta?.redirect,
    component: () => import("/home/forge/app.getgreengold.com/pages/cash-balance/withdraw/index.vue").then(m => m.default || m)
  },
  {
    name: indexrNTtlUUXX7Meta?.name ?? "cash-balance-withdraw___fr",
    path: indexrNTtlUUXX7Meta?.path ?? "/fr/cash-balance/withdraw",
    meta: indexrNTtlUUXX7Meta || {},
    alias: indexrNTtlUUXX7Meta?.alias || [],
    redirect: indexrNTtlUUXX7Meta?.redirect,
    component: () => import("/home/forge/app.getgreengold.com/pages/cash-balance/withdraw/index.vue").then(m => m.default || m)
  },
  {
    name: indexrNTtlUUXX7Meta?.name ?? "cash-balance-withdraw___nl",
    path: indexrNTtlUUXX7Meta?.path ?? "/nl/cash-balance/withdraw",
    meta: indexrNTtlUUXX7Meta || {},
    alias: indexrNTtlUUXX7Meta?.alias || [],
    redirect: indexrNTtlUUXX7Meta?.redirect,
    component: () => import("/home/forge/app.getgreengold.com/pages/cash-balance/withdraw/index.vue").then(m => m.default || m)
  },
  {
    name: dashboardUrO9X3q9kKMeta?.name ?? "dashboard___de",
    path: dashboardUrO9X3q9kKMeta?.path ?? "/de/dashboard",
    meta: dashboardUrO9X3q9kKMeta || {},
    alias: dashboardUrO9X3q9kKMeta?.alias || [],
    redirect: dashboardUrO9X3q9kKMeta?.redirect,
    component: () => import("/home/forge/app.getgreengold.com/pages/dashboard.vue").then(m => m.default || m)
  },
  {
    name: dashboardUrO9X3q9kKMeta?.name ?? "dashboard___en",
    path: dashboardUrO9X3q9kKMeta?.path ?? "/en/dashboard",
    meta: dashboardUrO9X3q9kKMeta || {},
    alias: dashboardUrO9X3q9kKMeta?.alias || [],
    redirect: dashboardUrO9X3q9kKMeta?.redirect,
    component: () => import("/home/forge/app.getgreengold.com/pages/dashboard.vue").then(m => m.default || m)
  },
  {
    name: dashboardUrO9X3q9kKMeta?.name ?? "dashboard___fr",
    path: dashboardUrO9X3q9kKMeta?.path ?? "/fr/dashboard",
    meta: dashboardUrO9X3q9kKMeta || {},
    alias: dashboardUrO9X3q9kKMeta?.alias || [],
    redirect: dashboardUrO9X3q9kKMeta?.redirect,
    component: () => import("/home/forge/app.getgreengold.com/pages/dashboard.vue").then(m => m.default || m)
  },
  {
    name: dashboardUrO9X3q9kKMeta?.name ?? "dashboard___nl",
    path: dashboardUrO9X3q9kKMeta?.path ?? "/nl/dashboard",
    meta: dashboardUrO9X3q9kKMeta || {},
    alias: dashboardUrO9X3q9kKMeta?.alias || [],
    redirect: dashboardUrO9X3q9kKMeta?.redirect,
    component: () => import("/home/forge/app.getgreengold.com/pages/dashboard.vue").then(m => m.default || m)
  },
  {
    name: _91type_93YbPz4DhbD7Meta?.name ?? "depot-type___de",
    path: _91type_93YbPz4DhbD7Meta?.path ?? "/de/depot/:type()",
    meta: _91type_93YbPz4DhbD7Meta || {},
    alias: _91type_93YbPz4DhbD7Meta?.alias || [],
    redirect: _91type_93YbPz4DhbD7Meta?.redirect,
    component: () => import("/home/forge/app.getgreengold.com/pages/depot/[type].vue").then(m => m.default || m)
  },
  {
    name: _91type_93YbPz4DhbD7Meta?.name ?? "depot-type___en",
    path: _91type_93YbPz4DhbD7Meta?.path ?? "/en/depot/:type()",
    meta: _91type_93YbPz4DhbD7Meta || {},
    alias: _91type_93YbPz4DhbD7Meta?.alias || [],
    redirect: _91type_93YbPz4DhbD7Meta?.redirect,
    component: () => import("/home/forge/app.getgreengold.com/pages/depot/[type].vue").then(m => m.default || m)
  },
  {
    name: _91type_93YbPz4DhbD7Meta?.name ?? "depot-type___fr",
    path: _91type_93YbPz4DhbD7Meta?.path ?? "/fr/depot/:type()",
    meta: _91type_93YbPz4DhbD7Meta || {},
    alias: _91type_93YbPz4DhbD7Meta?.alias || [],
    redirect: _91type_93YbPz4DhbD7Meta?.redirect,
    component: () => import("/home/forge/app.getgreengold.com/pages/depot/[type].vue").then(m => m.default || m)
  },
  {
    name: _91type_93YbPz4DhbD7Meta?.name ?? "depot-type___nl",
    path: _91type_93YbPz4DhbD7Meta?.path ?? "/nl/depot/:type()",
    meta: _91type_93YbPz4DhbD7Meta || {},
    alias: _91type_93YbPz4DhbD7Meta?.alias || [],
    redirect: _91type_93YbPz4DhbD7Meta?.redirect,
    component: () => import("/home/forge/app.getgreengold.com/pages/depot/[type].vue").then(m => m.default || m)
  },
  {
    name: _91id_93HR4execf2IMeta?.name ?? "depot-addsavingplan-id___de",
    path: _91id_93HR4execf2IMeta?.path ?? "/de/depot/addsavingplan/:id()",
    meta: _91id_93HR4execf2IMeta || {},
    alias: _91id_93HR4execf2IMeta?.alias || [],
    redirect: _91id_93HR4execf2IMeta?.redirect,
    component: () => import("/home/forge/app.getgreengold.com/pages/depot/addsavingplan/[id].vue").then(m => m.default || m)
  },
  {
    name: _91id_93HR4execf2IMeta?.name ?? "depot-addsavingplan-id___en",
    path: _91id_93HR4execf2IMeta?.path ?? "/en/depot/addsavingplan/:id()",
    meta: _91id_93HR4execf2IMeta || {},
    alias: _91id_93HR4execf2IMeta?.alias || [],
    redirect: _91id_93HR4execf2IMeta?.redirect,
    component: () => import("/home/forge/app.getgreengold.com/pages/depot/addsavingplan/[id].vue").then(m => m.default || m)
  },
  {
    name: _91id_93HR4execf2IMeta?.name ?? "depot-addsavingplan-id___fr",
    path: _91id_93HR4execf2IMeta?.path ?? "/fr/depot/addsavingplan/:id()",
    meta: _91id_93HR4execf2IMeta || {},
    alias: _91id_93HR4execf2IMeta?.alias || [],
    redirect: _91id_93HR4execf2IMeta?.redirect,
    component: () => import("/home/forge/app.getgreengold.com/pages/depot/addsavingplan/[id].vue").then(m => m.default || m)
  },
  {
    name: _91id_93HR4execf2IMeta?.name ?? "depot-addsavingplan-id___nl",
    path: _91id_93HR4execf2IMeta?.path ?? "/nl/depot/addsavingplan/:id()",
    meta: _91id_93HR4execf2IMeta || {},
    alias: _91id_93HR4execf2IMeta?.alias || [],
    redirect: _91id_93HR4execf2IMeta?.redirect,
    component: () => import("/home/forge/app.getgreengold.com/pages/depot/addsavingplan/[id].vue").then(m => m.default || m)
  },
  {
    name: _91id_93OKKhEdAlyhMeta?.name ?? "depot-detail-id___de",
    path: _91id_93OKKhEdAlyhMeta?.path ?? "/de/depot/detail/:id()",
    meta: _91id_93OKKhEdAlyhMeta || {},
    alias: _91id_93OKKhEdAlyhMeta?.alias || [],
    redirect: _91id_93OKKhEdAlyhMeta?.redirect,
    component: () => import("/home/forge/app.getgreengold.com/pages/depot/detail/[id].vue").then(m => m.default || m)
  },
  {
    name: _91id_93OKKhEdAlyhMeta?.name ?? "depot-detail-id___en",
    path: _91id_93OKKhEdAlyhMeta?.path ?? "/en/depot/detail/:id()",
    meta: _91id_93OKKhEdAlyhMeta || {},
    alias: _91id_93OKKhEdAlyhMeta?.alias || [],
    redirect: _91id_93OKKhEdAlyhMeta?.redirect,
    component: () => import("/home/forge/app.getgreengold.com/pages/depot/detail/[id].vue").then(m => m.default || m)
  },
  {
    name: _91id_93OKKhEdAlyhMeta?.name ?? "depot-detail-id___fr",
    path: _91id_93OKKhEdAlyhMeta?.path ?? "/fr/depot/detail/:id()",
    meta: _91id_93OKKhEdAlyhMeta || {},
    alias: _91id_93OKKhEdAlyhMeta?.alias || [],
    redirect: _91id_93OKKhEdAlyhMeta?.redirect,
    component: () => import("/home/forge/app.getgreengold.com/pages/depot/detail/[id].vue").then(m => m.default || m)
  },
  {
    name: _91id_93OKKhEdAlyhMeta?.name ?? "depot-detail-id___nl",
    path: _91id_93OKKhEdAlyhMeta?.path ?? "/nl/depot/detail/:id()",
    meta: _91id_93OKKhEdAlyhMeta || {},
    alias: _91id_93OKKhEdAlyhMeta?.alias || [],
    redirect: _91id_93OKKhEdAlyhMeta?.redirect,
    component: () => import("/home/forge/app.getgreengold.com/pages/depot/detail/[id].vue").then(m => m.default || m)
  },
  {
    name: _91type_93R9ll6Vxy6oMeta?.name ?? "depot-new-type___de",
    path: _91type_93R9ll6Vxy6oMeta?.path ?? "/de/depot/new/:type()",
    meta: _91type_93R9ll6Vxy6oMeta || {},
    alias: _91type_93R9ll6Vxy6oMeta?.alias || [],
    redirect: _91type_93R9ll6Vxy6oMeta?.redirect,
    component: () => import("/home/forge/app.getgreengold.com/pages/depot/new/[type].vue").then(m => m.default || m)
  },
  {
    name: _91type_93R9ll6Vxy6oMeta?.name ?? "depot-new-type___en",
    path: _91type_93R9ll6Vxy6oMeta?.path ?? "/en/depot/new/:type()",
    meta: _91type_93R9ll6Vxy6oMeta || {},
    alias: _91type_93R9ll6Vxy6oMeta?.alias || [],
    redirect: _91type_93R9ll6Vxy6oMeta?.redirect,
    component: () => import("/home/forge/app.getgreengold.com/pages/depot/new/[type].vue").then(m => m.default || m)
  },
  {
    name: _91type_93R9ll6Vxy6oMeta?.name ?? "depot-new-type___fr",
    path: _91type_93R9ll6Vxy6oMeta?.path ?? "/fr/depot/new/:type()",
    meta: _91type_93R9ll6Vxy6oMeta || {},
    alias: _91type_93R9ll6Vxy6oMeta?.alias || [],
    redirect: _91type_93R9ll6Vxy6oMeta?.redirect,
    component: () => import("/home/forge/app.getgreengold.com/pages/depot/new/[type].vue").then(m => m.default || m)
  },
  {
    name: _91type_93R9ll6Vxy6oMeta?.name ?? "depot-new-type___nl",
    path: _91type_93R9ll6Vxy6oMeta?.path ?? "/nl/depot/new/:type()",
    meta: _91type_93R9ll6Vxy6oMeta || {},
    alias: _91type_93R9ll6Vxy6oMeta?.alias || [],
    redirect: _91type_93R9ll6Vxy6oMeta?.redirect,
    component: () => import("/home/forge/app.getgreengold.com/pages/depot/new/[type].vue").then(m => m.default || m)
  },
  {
    name: indexIgEusYBR7BMeta?.name ?? "etf-transaction-history___de",
    path: indexIgEusYBR7BMeta?.path ?? "/de/etf-transaction-history",
    meta: indexIgEusYBR7BMeta || {},
    alias: indexIgEusYBR7BMeta?.alias || [],
    redirect: indexIgEusYBR7BMeta?.redirect,
    component: () => import("/home/forge/app.getgreengold.com/pages/etf-transaction-history/index.vue").then(m => m.default || m)
  },
  {
    name: indexIgEusYBR7BMeta?.name ?? "etf-transaction-history___en",
    path: indexIgEusYBR7BMeta?.path ?? "/en/etf-transaction-history",
    meta: indexIgEusYBR7BMeta || {},
    alias: indexIgEusYBR7BMeta?.alias || [],
    redirect: indexIgEusYBR7BMeta?.redirect,
    component: () => import("/home/forge/app.getgreengold.com/pages/etf-transaction-history/index.vue").then(m => m.default || m)
  },
  {
    name: indexIgEusYBR7BMeta?.name ?? "etf-transaction-history___fr",
    path: indexIgEusYBR7BMeta?.path ?? "/fr/etf-transaction-history",
    meta: indexIgEusYBR7BMeta || {},
    alias: indexIgEusYBR7BMeta?.alias || [],
    redirect: indexIgEusYBR7BMeta?.redirect,
    component: () => import("/home/forge/app.getgreengold.com/pages/etf-transaction-history/index.vue").then(m => m.default || m)
  },
  {
    name: indexIgEusYBR7BMeta?.name ?? "etf-transaction-history___nl",
    path: indexIgEusYBR7BMeta?.path ?? "/nl/etf-transaction-history",
    meta: indexIgEusYBR7BMeta || {},
    alias: indexIgEusYBR7BMeta?.alias || [],
    redirect: indexIgEusYBR7BMeta?.redirect,
    component: () => import("/home/forge/app.getgreengold.com/pages/etf-transaction-history/index.vue").then(m => m.default || m)
  },
  {
    name: indexToqKYMH7KuMeta?.name ?? "inbox-message___de",
    path: indexToqKYMH7KuMeta?.path ?? "/de/inbox-message",
    meta: indexToqKYMH7KuMeta || {},
    alias: indexToqKYMH7KuMeta?.alias || [],
    redirect: indexToqKYMH7KuMeta?.redirect,
    component: () => import("/home/forge/app.getgreengold.com/pages/inbox-message/index.vue").then(m => m.default || m)
  },
  {
    name: indexToqKYMH7KuMeta?.name ?? "inbox-message___en",
    path: indexToqKYMH7KuMeta?.path ?? "/en/inbox-message",
    meta: indexToqKYMH7KuMeta || {},
    alias: indexToqKYMH7KuMeta?.alias || [],
    redirect: indexToqKYMH7KuMeta?.redirect,
    component: () => import("/home/forge/app.getgreengold.com/pages/inbox-message/index.vue").then(m => m.default || m)
  },
  {
    name: indexToqKYMH7KuMeta?.name ?? "inbox-message___fr",
    path: indexToqKYMH7KuMeta?.path ?? "/fr/inbox-message",
    meta: indexToqKYMH7KuMeta || {},
    alias: indexToqKYMH7KuMeta?.alias || [],
    redirect: indexToqKYMH7KuMeta?.redirect,
    component: () => import("/home/forge/app.getgreengold.com/pages/inbox-message/index.vue").then(m => m.default || m)
  },
  {
    name: indexToqKYMH7KuMeta?.name ?? "inbox-message___nl",
    path: indexToqKYMH7KuMeta?.path ?? "/nl/inbox-message",
    meta: indexToqKYMH7KuMeta || {},
    alias: indexToqKYMH7KuMeta?.alias || [],
    redirect: indexToqKYMH7KuMeta?.redirect,
    component: () => import("/home/forge/app.getgreengold.com/pages/inbox-message/index.vue").then(m => m.default || m)
  },
  {
    name: indexPfzQq59IOhMeta?.name ?? "index___de",
    path: indexPfzQq59IOhMeta?.path ?? "/de",
    meta: indexPfzQq59IOhMeta || {},
    alias: indexPfzQq59IOhMeta?.alias || [],
    redirect: indexPfzQq59IOhMeta?.redirect,
    component: () => import("/home/forge/app.getgreengold.com/pages/index.vue").then(m => m.default || m)
  },
  {
    name: indexPfzQq59IOhMeta?.name ?? "index___en",
    path: indexPfzQq59IOhMeta?.path ?? "/en",
    meta: indexPfzQq59IOhMeta || {},
    alias: indexPfzQq59IOhMeta?.alias || [],
    redirect: indexPfzQq59IOhMeta?.redirect,
    component: () => import("/home/forge/app.getgreengold.com/pages/index.vue").then(m => m.default || m)
  },
  {
    name: indexPfzQq59IOhMeta?.name ?? "index___fr",
    path: indexPfzQq59IOhMeta?.path ?? "/fr",
    meta: indexPfzQq59IOhMeta || {},
    alias: indexPfzQq59IOhMeta?.alias || [],
    redirect: indexPfzQq59IOhMeta?.redirect,
    component: () => import("/home/forge/app.getgreengold.com/pages/index.vue").then(m => m.default || m)
  },
  {
    name: indexPfzQq59IOhMeta?.name ?? "index___nl",
    path: indexPfzQq59IOhMeta?.path ?? "/nl",
    meta: indexPfzQq59IOhMeta || {},
    alias: indexPfzQq59IOhMeta?.alias || [],
    redirect: indexPfzQq59IOhMeta?.redirect,
    component: () => import("/home/forge/app.getgreengold.com/pages/index.vue").then(m => m.default || m)
  },
  {
    name: _91_91isin_93_93cb9fCgkinBMeta?.name ?? "instruments-buy-isin___de",
    path: _91_91isin_93_93cb9fCgkinBMeta?.path ?? "/de/instruments/buy/:isin?",
    meta: _91_91isin_93_93cb9fCgkinBMeta || {},
    alias: _91_91isin_93_93cb9fCgkinBMeta?.alias || [],
    redirect: _91_91isin_93_93cb9fCgkinBMeta?.redirect,
    component: () => import("/home/forge/app.getgreengold.com/pages/instruments/buy/[[isin]].vue").then(m => m.default || m)
  },
  {
    name: _91_91isin_93_93cb9fCgkinBMeta?.name ?? "instruments-buy-isin___en",
    path: _91_91isin_93_93cb9fCgkinBMeta?.path ?? "/en/instruments/buy/:isin?",
    meta: _91_91isin_93_93cb9fCgkinBMeta || {},
    alias: _91_91isin_93_93cb9fCgkinBMeta?.alias || [],
    redirect: _91_91isin_93_93cb9fCgkinBMeta?.redirect,
    component: () => import("/home/forge/app.getgreengold.com/pages/instruments/buy/[[isin]].vue").then(m => m.default || m)
  },
  {
    name: _91_91isin_93_93cb9fCgkinBMeta?.name ?? "instruments-buy-isin___fr",
    path: _91_91isin_93_93cb9fCgkinBMeta?.path ?? "/fr/instruments/buy/:isin?",
    meta: _91_91isin_93_93cb9fCgkinBMeta || {},
    alias: _91_91isin_93_93cb9fCgkinBMeta?.alias || [],
    redirect: _91_91isin_93_93cb9fCgkinBMeta?.redirect,
    component: () => import("/home/forge/app.getgreengold.com/pages/instruments/buy/[[isin]].vue").then(m => m.default || m)
  },
  {
    name: _91_91isin_93_93cb9fCgkinBMeta?.name ?? "instruments-buy-isin___nl",
    path: _91_91isin_93_93cb9fCgkinBMeta?.path ?? "/nl/instruments/buy/:isin?",
    meta: _91_91isin_93_93cb9fCgkinBMeta || {},
    alias: _91_91isin_93_93cb9fCgkinBMeta?.alias || [],
    redirect: _91_91isin_93_93cb9fCgkinBMeta?.redirect,
    component: () => import("/home/forge/app.getgreengold.com/pages/instruments/buy/[[isin]].vue").then(m => m.default || m)
  },
  {
    name: _91isin_93c4OBt9LWd4Meta?.name ?? "instruments-details-isin___de",
    path: _91isin_93c4OBt9LWd4Meta?.path ?? "/de/instruments/details/:isin()",
    meta: _91isin_93c4OBt9LWd4Meta || {},
    alias: _91isin_93c4OBt9LWd4Meta?.alias || [],
    redirect: _91isin_93c4OBt9LWd4Meta?.redirect,
    component: () => import("/home/forge/app.getgreengold.com/pages/instruments/details/[isin].vue").then(m => m.default || m)
  },
  {
    name: _91isin_93c4OBt9LWd4Meta?.name ?? "instruments-details-isin___en",
    path: _91isin_93c4OBt9LWd4Meta?.path ?? "/en/instruments/details/:isin()",
    meta: _91isin_93c4OBt9LWd4Meta || {},
    alias: _91isin_93c4OBt9LWd4Meta?.alias || [],
    redirect: _91isin_93c4OBt9LWd4Meta?.redirect,
    component: () => import("/home/forge/app.getgreengold.com/pages/instruments/details/[isin].vue").then(m => m.default || m)
  },
  {
    name: _91isin_93c4OBt9LWd4Meta?.name ?? "instruments-details-isin___fr",
    path: _91isin_93c4OBt9LWd4Meta?.path ?? "/fr/instruments/details/:isin()",
    meta: _91isin_93c4OBt9LWd4Meta || {},
    alias: _91isin_93c4OBt9LWd4Meta?.alias || [],
    redirect: _91isin_93c4OBt9LWd4Meta?.redirect,
    component: () => import("/home/forge/app.getgreengold.com/pages/instruments/details/[isin].vue").then(m => m.default || m)
  },
  {
    name: _91isin_93c4OBt9LWd4Meta?.name ?? "instruments-details-isin___nl",
    path: _91isin_93c4OBt9LWd4Meta?.path ?? "/nl/instruments/details/:isin()",
    meta: _91isin_93c4OBt9LWd4Meta || {},
    alias: _91isin_93c4OBt9LWd4Meta?.alias || [],
    redirect: _91isin_93c4OBt9LWd4Meta?.redirect,
    component: () => import("/home/forge/app.getgreengold.com/pages/instruments/details/[isin].vue").then(m => m.default || m)
  },
  {
    name: index_oldIcWNrzpazrMeta?.name ?? "instruments-index_old___de",
    path: index_oldIcWNrzpazrMeta?.path ?? "/de/instruments/index_old",
    meta: index_oldIcWNrzpazrMeta || {},
    alias: index_oldIcWNrzpazrMeta?.alias || [],
    redirect: index_oldIcWNrzpazrMeta?.redirect,
    component: () => import("/home/forge/app.getgreengold.com/pages/instruments/index_old.vue").then(m => m.default || m)
  },
  {
    name: index_oldIcWNrzpazrMeta?.name ?? "instruments-index_old___en",
    path: index_oldIcWNrzpazrMeta?.path ?? "/en/instruments/index_old",
    meta: index_oldIcWNrzpazrMeta || {},
    alias: index_oldIcWNrzpazrMeta?.alias || [],
    redirect: index_oldIcWNrzpazrMeta?.redirect,
    component: () => import("/home/forge/app.getgreengold.com/pages/instruments/index_old.vue").then(m => m.default || m)
  },
  {
    name: index_oldIcWNrzpazrMeta?.name ?? "instruments-index_old___fr",
    path: index_oldIcWNrzpazrMeta?.path ?? "/fr/instruments/index_old",
    meta: index_oldIcWNrzpazrMeta || {},
    alias: index_oldIcWNrzpazrMeta?.alias || [],
    redirect: index_oldIcWNrzpazrMeta?.redirect,
    component: () => import("/home/forge/app.getgreengold.com/pages/instruments/index_old.vue").then(m => m.default || m)
  },
  {
    name: index_oldIcWNrzpazrMeta?.name ?? "instruments-index_old___nl",
    path: index_oldIcWNrzpazrMeta?.path ?? "/nl/instruments/index_old",
    meta: index_oldIcWNrzpazrMeta || {},
    alias: index_oldIcWNrzpazrMeta?.alias || [],
    redirect: index_oldIcWNrzpazrMeta?.redirect,
    component: () => import("/home/forge/app.getgreengold.com/pages/instruments/index_old.vue").then(m => m.default || m)
  },
  {
    name: indexHqyoBoVvi9Meta?.name ?? "instruments___de",
    path: indexHqyoBoVvi9Meta?.path ?? "/de/instruments",
    meta: indexHqyoBoVvi9Meta || {},
    alias: indexHqyoBoVvi9Meta?.alias || [],
    redirect: indexHqyoBoVvi9Meta?.redirect,
    component: () => import("/home/forge/app.getgreengold.com/pages/instruments/index.vue").then(m => m.default || m)
  },
  {
    name: indexHqyoBoVvi9Meta?.name ?? "instruments___en",
    path: indexHqyoBoVvi9Meta?.path ?? "/en/instruments",
    meta: indexHqyoBoVvi9Meta || {},
    alias: indexHqyoBoVvi9Meta?.alias || [],
    redirect: indexHqyoBoVvi9Meta?.redirect,
    component: () => import("/home/forge/app.getgreengold.com/pages/instruments/index.vue").then(m => m.default || m)
  },
  {
    name: indexHqyoBoVvi9Meta?.name ?? "instruments___fr",
    path: indexHqyoBoVvi9Meta?.path ?? "/fr/instruments",
    meta: indexHqyoBoVvi9Meta || {},
    alias: indexHqyoBoVvi9Meta?.alias || [],
    redirect: indexHqyoBoVvi9Meta?.redirect,
    component: () => import("/home/forge/app.getgreengold.com/pages/instruments/index.vue").then(m => m.default || m)
  },
  {
    name: indexHqyoBoVvi9Meta?.name ?? "instruments___nl",
    path: indexHqyoBoVvi9Meta?.path ?? "/nl/instruments",
    meta: indexHqyoBoVvi9Meta || {},
    alias: indexHqyoBoVvi9Meta?.alias || [],
    redirect: indexHqyoBoVvi9Meta?.redirect,
    component: () => import("/home/forge/app.getgreengold.com/pages/instruments/index.vue").then(m => m.default || m)
  },
  {
    name: indexOVtT4de8uJMeta?.name ?? "instruments-list___de",
    path: indexOVtT4de8uJMeta?.path ?? "/de/instruments/list",
    meta: indexOVtT4de8uJMeta || {},
    alias: indexOVtT4de8uJMeta?.alias || [],
    redirect: indexOVtT4de8uJMeta?.redirect,
    component: () => import("/home/forge/app.getgreengold.com/pages/instruments/list/index.vue").then(m => m.default || m)
  },
  {
    name: indexOVtT4de8uJMeta?.name ?? "instruments-list___en",
    path: indexOVtT4de8uJMeta?.path ?? "/en/instruments/list",
    meta: indexOVtT4de8uJMeta || {},
    alias: indexOVtT4de8uJMeta?.alias || [],
    redirect: indexOVtT4de8uJMeta?.redirect,
    component: () => import("/home/forge/app.getgreengold.com/pages/instruments/list/index.vue").then(m => m.default || m)
  },
  {
    name: indexOVtT4de8uJMeta?.name ?? "instruments-list___fr",
    path: indexOVtT4de8uJMeta?.path ?? "/fr/instruments/list",
    meta: indexOVtT4de8uJMeta || {},
    alias: indexOVtT4de8uJMeta?.alias || [],
    redirect: indexOVtT4de8uJMeta?.redirect,
    component: () => import("/home/forge/app.getgreengold.com/pages/instruments/list/index.vue").then(m => m.default || m)
  },
  {
    name: indexOVtT4de8uJMeta?.name ?? "instruments-list___nl",
    path: indexOVtT4de8uJMeta?.path ?? "/nl/instruments/list",
    meta: indexOVtT4de8uJMeta || {},
    alias: indexOVtT4de8uJMeta?.alias || [],
    redirect: indexOVtT4de8uJMeta?.redirect,
    component: () => import("/home/forge/app.getgreengold.com/pages/instruments/list/index.vue").then(m => m.default || m)
  },
  {
    name: _91_91isin_93_93LJARvkTcRhMeta?.name ?? "instruments-savings-plan-add-isin___de",
    path: _91_91isin_93_93LJARvkTcRhMeta?.path ?? "/de/instruments/savings-plan/add/:isin?",
    meta: _91_91isin_93_93LJARvkTcRhMeta || {},
    alias: _91_91isin_93_93LJARvkTcRhMeta?.alias || [],
    redirect: _91_91isin_93_93LJARvkTcRhMeta?.redirect,
    component: () => import("/home/forge/app.getgreengold.com/pages/instruments/savings-plan/add/[[isin]].vue").then(m => m.default || m)
  },
  {
    name: _91_91isin_93_93LJARvkTcRhMeta?.name ?? "instruments-savings-plan-add-isin___en",
    path: _91_91isin_93_93LJARvkTcRhMeta?.path ?? "/en/instruments/savings-plan/add/:isin?",
    meta: _91_91isin_93_93LJARvkTcRhMeta || {},
    alias: _91_91isin_93_93LJARvkTcRhMeta?.alias || [],
    redirect: _91_91isin_93_93LJARvkTcRhMeta?.redirect,
    component: () => import("/home/forge/app.getgreengold.com/pages/instruments/savings-plan/add/[[isin]].vue").then(m => m.default || m)
  },
  {
    name: _91_91isin_93_93LJARvkTcRhMeta?.name ?? "instruments-savings-plan-add-isin___fr",
    path: _91_91isin_93_93LJARvkTcRhMeta?.path ?? "/fr/instruments/savings-plan/add/:isin?",
    meta: _91_91isin_93_93LJARvkTcRhMeta || {},
    alias: _91_91isin_93_93LJARvkTcRhMeta?.alias || [],
    redirect: _91_91isin_93_93LJARvkTcRhMeta?.redirect,
    component: () => import("/home/forge/app.getgreengold.com/pages/instruments/savings-plan/add/[[isin]].vue").then(m => m.default || m)
  },
  {
    name: _91_91isin_93_93LJARvkTcRhMeta?.name ?? "instruments-savings-plan-add-isin___nl",
    path: _91_91isin_93_93LJARvkTcRhMeta?.path ?? "/nl/instruments/savings-plan/add/:isin?",
    meta: _91_91isin_93_93LJARvkTcRhMeta || {},
    alias: _91_91isin_93_93LJARvkTcRhMeta?.alias || [],
    redirect: _91_91isin_93_93LJARvkTcRhMeta?.redirect,
    component: () => import("/home/forge/app.getgreengold.com/pages/instruments/savings-plan/add/[[isin]].vue").then(m => m.default || m)
  },
  {
    name: _91_91isin_93_932Gh8YSXTNaMeta?.name ?? "instruments-sell-isin___de",
    path: _91_91isin_93_932Gh8YSXTNaMeta?.path ?? "/de/instruments/sell/:isin?",
    meta: _91_91isin_93_932Gh8YSXTNaMeta || {},
    alias: _91_91isin_93_932Gh8YSXTNaMeta?.alias || [],
    redirect: _91_91isin_93_932Gh8YSXTNaMeta?.redirect,
    component: () => import("/home/forge/app.getgreengold.com/pages/instruments/sell/[[isin]].vue").then(m => m.default || m)
  },
  {
    name: _91_91isin_93_932Gh8YSXTNaMeta?.name ?? "instruments-sell-isin___en",
    path: _91_91isin_93_932Gh8YSXTNaMeta?.path ?? "/en/instruments/sell/:isin?",
    meta: _91_91isin_93_932Gh8YSXTNaMeta || {},
    alias: _91_91isin_93_932Gh8YSXTNaMeta?.alias || [],
    redirect: _91_91isin_93_932Gh8YSXTNaMeta?.redirect,
    component: () => import("/home/forge/app.getgreengold.com/pages/instruments/sell/[[isin]].vue").then(m => m.default || m)
  },
  {
    name: _91_91isin_93_932Gh8YSXTNaMeta?.name ?? "instruments-sell-isin___fr",
    path: _91_91isin_93_932Gh8YSXTNaMeta?.path ?? "/fr/instruments/sell/:isin?",
    meta: _91_91isin_93_932Gh8YSXTNaMeta || {},
    alias: _91_91isin_93_932Gh8YSXTNaMeta?.alias || [],
    redirect: _91_91isin_93_932Gh8YSXTNaMeta?.redirect,
    component: () => import("/home/forge/app.getgreengold.com/pages/instruments/sell/[[isin]].vue").then(m => m.default || m)
  },
  {
    name: _91_91isin_93_932Gh8YSXTNaMeta?.name ?? "instruments-sell-isin___nl",
    path: _91_91isin_93_932Gh8YSXTNaMeta?.path ?? "/nl/instruments/sell/:isin?",
    meta: _91_91isin_93_932Gh8YSXTNaMeta || {},
    alias: _91_91isin_93_932Gh8YSXTNaMeta?.alias || [],
    redirect: _91_91isin_93_932Gh8YSXTNaMeta?.redirect,
    component: () => import("/home/forge/app.getgreengold.com/pages/instruments/sell/[[isin]].vue").then(m => m.default || m)
  },
  {
    name: indexYugK3oK2vRMeta?.name ?? "instruments-tax-exemption___de",
    path: indexYugK3oK2vRMeta?.path ?? "/de/instruments/tax-exemption",
    meta: indexYugK3oK2vRMeta || {},
    alias: indexYugK3oK2vRMeta?.alias || [],
    redirect: indexYugK3oK2vRMeta?.redirect,
    component: () => import("/home/forge/app.getgreengold.com/pages/instruments/tax-exemption/index.vue").then(m => m.default || m)
  },
  {
    name: indexYugK3oK2vRMeta?.name ?? "instruments-tax-exemption___en",
    path: indexYugK3oK2vRMeta?.path ?? "/en/instruments/tax-exemption",
    meta: indexYugK3oK2vRMeta || {},
    alias: indexYugK3oK2vRMeta?.alias || [],
    redirect: indexYugK3oK2vRMeta?.redirect,
    component: () => import("/home/forge/app.getgreengold.com/pages/instruments/tax-exemption/index.vue").then(m => m.default || m)
  },
  {
    name: indexYugK3oK2vRMeta?.name ?? "instruments-tax-exemption___fr",
    path: indexYugK3oK2vRMeta?.path ?? "/fr/instruments/tax-exemption",
    meta: indexYugK3oK2vRMeta || {},
    alias: indexYugK3oK2vRMeta?.alias || [],
    redirect: indexYugK3oK2vRMeta?.redirect,
    component: () => import("/home/forge/app.getgreengold.com/pages/instruments/tax-exemption/index.vue").then(m => m.default || m)
  },
  {
    name: indexYugK3oK2vRMeta?.name ?? "instruments-tax-exemption___nl",
    path: indexYugK3oK2vRMeta?.path ?? "/nl/instruments/tax-exemption",
    meta: indexYugK3oK2vRMeta || {},
    alias: indexYugK3oK2vRMeta?.alias || [],
    redirect: indexYugK3oK2vRMeta?.redirect,
    component: () => import("/home/forge/app.getgreengold.com/pages/instruments/tax-exemption/index.vue").then(m => m.default || m)
  },
  {
    name: loginUBy2MqfbiQMeta?.name ?? "login___de",
    path: loginUBy2MqfbiQMeta?.path ?? "/de/login",
    meta: loginUBy2MqfbiQMeta || {},
    alias: loginUBy2MqfbiQMeta?.alias || [],
    redirect: loginUBy2MqfbiQMeta?.redirect,
    component: () => import("/home/forge/app.getgreengold.com/pages/login.vue").then(m => m.default || m)
  },
  {
    name: loginUBy2MqfbiQMeta?.name ?? "login___en",
    path: loginUBy2MqfbiQMeta?.path ?? "/en/login",
    meta: loginUBy2MqfbiQMeta || {},
    alias: loginUBy2MqfbiQMeta?.alias || [],
    redirect: loginUBy2MqfbiQMeta?.redirect,
    component: () => import("/home/forge/app.getgreengold.com/pages/login.vue").then(m => m.default || m)
  },
  {
    name: loginUBy2MqfbiQMeta?.name ?? "login___fr",
    path: loginUBy2MqfbiQMeta?.path ?? "/fr/login",
    meta: loginUBy2MqfbiQMeta || {},
    alias: loginUBy2MqfbiQMeta?.alias || [],
    redirect: loginUBy2MqfbiQMeta?.redirect,
    component: () => import("/home/forge/app.getgreengold.com/pages/login.vue").then(m => m.default || m)
  },
  {
    name: loginUBy2MqfbiQMeta?.name ?? "login___nl",
    path: loginUBy2MqfbiQMeta?.path ?? "/nl/login",
    meta: loginUBy2MqfbiQMeta || {},
    alias: loginUBy2MqfbiQMeta?.alias || [],
    redirect: loginUBy2MqfbiQMeta?.redirect,
    component: () => import("/home/forge/app.getgreengold.com/pages/login.vue").then(m => m.default || m)
  },
  {
    name: index73UzsvxM2KMeta?.name ?? "profile___de",
    path: index73UzsvxM2KMeta?.path ?? "/de/profile",
    meta: index73UzsvxM2KMeta || {},
    alias: index73UzsvxM2KMeta?.alias || [],
    redirect: index73UzsvxM2KMeta?.redirect,
    component: () => import("/home/forge/app.getgreengold.com/pages/profile/index.vue").then(m => m.default || m)
  },
  {
    name: index73UzsvxM2KMeta?.name ?? "profile___en",
    path: index73UzsvxM2KMeta?.path ?? "/en/profile",
    meta: index73UzsvxM2KMeta || {},
    alias: index73UzsvxM2KMeta?.alias || [],
    redirect: index73UzsvxM2KMeta?.redirect,
    component: () => import("/home/forge/app.getgreengold.com/pages/profile/index.vue").then(m => m.default || m)
  },
  {
    name: index73UzsvxM2KMeta?.name ?? "profile___fr",
    path: index73UzsvxM2KMeta?.path ?? "/fr/profile",
    meta: index73UzsvxM2KMeta || {},
    alias: index73UzsvxM2KMeta?.alias || [],
    redirect: index73UzsvxM2KMeta?.redirect,
    component: () => import("/home/forge/app.getgreengold.com/pages/profile/index.vue").then(m => m.default || m)
  },
  {
    name: index73UzsvxM2KMeta?.name ?? "profile___nl",
    path: index73UzsvxM2KMeta?.path ?? "/nl/profile",
    meta: index73UzsvxM2KMeta || {},
    alias: index73UzsvxM2KMeta?.alias || [],
    redirect: index73UzsvxM2KMeta?.redirect,
    component: () => import("/home/forge/app.getgreengold.com/pages/profile/index.vue").then(m => m.default || m)
  },
  {
    name: verifyRDpRXGVuOCMeta?.name ?? "profile-verify___de",
    path: verifyRDpRXGVuOCMeta?.path ?? "/de/profile/verify",
    meta: verifyRDpRXGVuOCMeta || {},
    alias: verifyRDpRXGVuOCMeta?.alias || [],
    redirect: verifyRDpRXGVuOCMeta?.redirect,
    component: () => import("/home/forge/app.getgreengold.com/pages/profile/verify.vue").then(m => m.default || m)
  },
  {
    name: verifyRDpRXGVuOCMeta?.name ?? "profile-verify___en",
    path: verifyRDpRXGVuOCMeta?.path ?? "/en/profile/verify",
    meta: verifyRDpRXGVuOCMeta || {},
    alias: verifyRDpRXGVuOCMeta?.alias || [],
    redirect: verifyRDpRXGVuOCMeta?.redirect,
    component: () => import("/home/forge/app.getgreengold.com/pages/profile/verify.vue").then(m => m.default || m)
  },
  {
    name: verifyRDpRXGVuOCMeta?.name ?? "profile-verify___fr",
    path: verifyRDpRXGVuOCMeta?.path ?? "/fr/profile/verify",
    meta: verifyRDpRXGVuOCMeta || {},
    alias: verifyRDpRXGVuOCMeta?.alias || [],
    redirect: verifyRDpRXGVuOCMeta?.redirect,
    component: () => import("/home/forge/app.getgreengold.com/pages/profile/verify.vue").then(m => m.default || m)
  },
  {
    name: verifyRDpRXGVuOCMeta?.name ?? "profile-verify___nl",
    path: verifyRDpRXGVuOCMeta?.path ?? "/nl/profile/verify",
    meta: verifyRDpRXGVuOCMeta || {},
    alias: verifyRDpRXGVuOCMeta?.alias || [],
    redirect: verifyRDpRXGVuOCMeta?.redirect,
    component: () => import("/home/forge/app.getgreengold.com/pages/profile/verify.vue").then(m => m.default || m)
  },
  {
    name: registerkgNhNitoBZMeta?.name ?? "register___de",
    path: registerkgNhNitoBZMeta?.path ?? "/de/register",
    meta: registerkgNhNitoBZMeta || {},
    alias: registerkgNhNitoBZMeta?.alias || [],
    redirect: registerkgNhNitoBZMeta?.redirect,
    component: () => import("/home/forge/app.getgreengold.com/pages/register.vue").then(m => m.default || m)
  },
  {
    name: registerkgNhNitoBZMeta?.name ?? "register___en",
    path: registerkgNhNitoBZMeta?.path ?? "/en/register",
    meta: registerkgNhNitoBZMeta || {},
    alias: registerkgNhNitoBZMeta?.alias || [],
    redirect: registerkgNhNitoBZMeta?.redirect,
    component: () => import("/home/forge/app.getgreengold.com/pages/register.vue").then(m => m.default || m)
  },
  {
    name: registerkgNhNitoBZMeta?.name ?? "register___fr",
    path: registerkgNhNitoBZMeta?.path ?? "/fr/register",
    meta: registerkgNhNitoBZMeta || {},
    alias: registerkgNhNitoBZMeta?.alias || [],
    redirect: registerkgNhNitoBZMeta?.redirect,
    component: () => import("/home/forge/app.getgreengold.com/pages/register.vue").then(m => m.default || m)
  },
  {
    name: registerkgNhNitoBZMeta?.name ?? "register___nl",
    path: registerkgNhNitoBZMeta?.path ?? "/nl/register",
    meta: registerkgNhNitoBZMeta || {},
    alias: registerkgNhNitoBZMeta?.alias || [],
    redirect: registerkgNhNitoBZMeta?.redirect,
    component: () => import("/home/forge/app.getgreengold.com/pages/register.vue").then(m => m.default || m)
  },
  {
    name: request_45passwordb10KC7EvUoMeta?.name ?? "request-password___de",
    path: request_45passwordb10KC7EvUoMeta?.path ?? "/de/request-password",
    meta: request_45passwordb10KC7EvUoMeta || {},
    alias: request_45passwordb10KC7EvUoMeta?.alias || [],
    redirect: request_45passwordb10KC7EvUoMeta?.redirect,
    component: () => import("/home/forge/app.getgreengold.com/pages/request-password.vue").then(m => m.default || m)
  },
  {
    name: request_45passwordb10KC7EvUoMeta?.name ?? "request-password___en",
    path: request_45passwordb10KC7EvUoMeta?.path ?? "/en/request-password",
    meta: request_45passwordb10KC7EvUoMeta || {},
    alias: request_45passwordb10KC7EvUoMeta?.alias || [],
    redirect: request_45passwordb10KC7EvUoMeta?.redirect,
    component: () => import("/home/forge/app.getgreengold.com/pages/request-password.vue").then(m => m.default || m)
  },
  {
    name: request_45passwordb10KC7EvUoMeta?.name ?? "request-password___fr",
    path: request_45passwordb10KC7EvUoMeta?.path ?? "/fr/request-password",
    meta: request_45passwordb10KC7EvUoMeta || {},
    alias: request_45passwordb10KC7EvUoMeta?.alias || [],
    redirect: request_45passwordb10KC7EvUoMeta?.redirect,
    component: () => import("/home/forge/app.getgreengold.com/pages/request-password.vue").then(m => m.default || m)
  },
  {
    name: request_45passwordb10KC7EvUoMeta?.name ?? "request-password___nl",
    path: request_45passwordb10KC7EvUoMeta?.path ?? "/nl/request-password",
    meta: request_45passwordb10KC7EvUoMeta || {},
    alias: request_45passwordb10KC7EvUoMeta?.alias || [],
    redirect: request_45passwordb10KC7EvUoMeta?.redirect,
    component: () => import("/home/forge/app.getgreengold.com/pages/request-password.vue").then(m => m.default || m)
  },
  {
    name: reset_45passwordJAZDhGxgvMMeta?.name ?? "reset-password___de",
    path: reset_45passwordJAZDhGxgvMMeta?.path ?? "/de/reset-password",
    meta: reset_45passwordJAZDhGxgvMMeta || {},
    alias: reset_45passwordJAZDhGxgvMMeta?.alias || [],
    redirect: reset_45passwordJAZDhGxgvMMeta?.redirect,
    component: () => import("/home/forge/app.getgreengold.com/pages/reset-password.vue").then(m => m.default || m)
  },
  {
    name: reset_45passwordJAZDhGxgvMMeta?.name ?? "reset-password___en",
    path: reset_45passwordJAZDhGxgvMMeta?.path ?? "/en/reset-password",
    meta: reset_45passwordJAZDhGxgvMMeta || {},
    alias: reset_45passwordJAZDhGxgvMMeta?.alias || [],
    redirect: reset_45passwordJAZDhGxgvMMeta?.redirect,
    component: () => import("/home/forge/app.getgreengold.com/pages/reset-password.vue").then(m => m.default || m)
  },
  {
    name: reset_45passwordJAZDhGxgvMMeta?.name ?? "reset-password___fr",
    path: reset_45passwordJAZDhGxgvMMeta?.path ?? "/fr/reset-password",
    meta: reset_45passwordJAZDhGxgvMMeta || {},
    alias: reset_45passwordJAZDhGxgvMMeta?.alias || [],
    redirect: reset_45passwordJAZDhGxgvMMeta?.redirect,
    component: () => import("/home/forge/app.getgreengold.com/pages/reset-password.vue").then(m => m.default || m)
  },
  {
    name: reset_45passwordJAZDhGxgvMMeta?.name ?? "reset-password___nl",
    path: reset_45passwordJAZDhGxgvMMeta?.path ?? "/nl/reset-password",
    meta: reset_45passwordJAZDhGxgvMMeta || {},
    alias: reset_45passwordJAZDhGxgvMMeta?.alias || [],
    redirect: reset_45passwordJAZDhGxgvMMeta?.redirect,
    component: () => import("/home/forge/app.getgreengold.com/pages/reset-password.vue").then(m => m.default || m)
  },
  {
    name: reset_45pinUHLTOflYeTMeta?.name ?? "reset-pin___de",
    path: reset_45pinUHLTOflYeTMeta?.path ?? "/de/reset-pin",
    meta: reset_45pinUHLTOflYeTMeta || {},
    alias: reset_45pinUHLTOflYeTMeta?.alias || [],
    redirect: reset_45pinUHLTOflYeTMeta?.redirect,
    component: () => import("/home/forge/app.getgreengold.com/pages/reset-pin.vue").then(m => m.default || m)
  },
  {
    name: reset_45pinUHLTOflYeTMeta?.name ?? "reset-pin___en",
    path: reset_45pinUHLTOflYeTMeta?.path ?? "/en/reset-pin",
    meta: reset_45pinUHLTOflYeTMeta || {},
    alias: reset_45pinUHLTOflYeTMeta?.alias || [],
    redirect: reset_45pinUHLTOflYeTMeta?.redirect,
    component: () => import("/home/forge/app.getgreengold.com/pages/reset-pin.vue").then(m => m.default || m)
  },
  {
    name: reset_45pinUHLTOflYeTMeta?.name ?? "reset-pin___fr",
    path: reset_45pinUHLTOflYeTMeta?.path ?? "/fr/reset-pin",
    meta: reset_45pinUHLTOflYeTMeta || {},
    alias: reset_45pinUHLTOflYeTMeta?.alias || [],
    redirect: reset_45pinUHLTOflYeTMeta?.redirect,
    component: () => import("/home/forge/app.getgreengold.com/pages/reset-pin.vue").then(m => m.default || m)
  },
  {
    name: reset_45pinUHLTOflYeTMeta?.name ?? "reset-pin___nl",
    path: reset_45pinUHLTOflYeTMeta?.path ?? "/nl/reset-pin",
    meta: reset_45pinUHLTOflYeTMeta || {},
    alias: reset_45pinUHLTOflYeTMeta?.alias || [],
    redirect: reset_45pinUHLTOflYeTMeta?.redirect,
    component: () => import("/home/forge/app.getgreengold.com/pages/reset-pin.vue").then(m => m.default || m)
  },
  {
    name: indexvFVU1daJV8Meta?.name ?? "security-legal-document___de",
    path: indexvFVU1daJV8Meta?.path ?? "/de/security-legal-document",
    meta: indexvFVU1daJV8Meta || {},
    alias: indexvFVU1daJV8Meta?.alias || [],
    redirect: indexvFVU1daJV8Meta?.redirect,
    component: () => import("/home/forge/app.getgreengold.com/pages/security-legal-document/index.vue").then(m => m.default || m)
  },
  {
    name: indexvFVU1daJV8Meta?.name ?? "security-legal-document___en",
    path: indexvFVU1daJV8Meta?.path ?? "/en/security-legal-document",
    meta: indexvFVU1daJV8Meta || {},
    alias: indexvFVU1daJV8Meta?.alias || [],
    redirect: indexvFVU1daJV8Meta?.redirect,
    component: () => import("/home/forge/app.getgreengold.com/pages/security-legal-document/index.vue").then(m => m.default || m)
  },
  {
    name: indexvFVU1daJV8Meta?.name ?? "security-legal-document___fr",
    path: indexvFVU1daJV8Meta?.path ?? "/fr/security-legal-document",
    meta: indexvFVU1daJV8Meta || {},
    alias: indexvFVU1daJV8Meta?.alias || [],
    redirect: indexvFVU1daJV8Meta?.redirect,
    component: () => import("/home/forge/app.getgreengold.com/pages/security-legal-document/index.vue").then(m => m.default || m)
  },
  {
    name: indexvFVU1daJV8Meta?.name ?? "security-legal-document___nl",
    path: indexvFVU1daJV8Meta?.path ?? "/nl/security-legal-document",
    meta: indexvFVU1daJV8Meta || {},
    alias: indexvFVU1daJV8Meta?.alias || [],
    redirect: indexvFVU1daJV8Meta?.redirect,
    component: () => import("/home/forge/app.getgreengold.com/pages/security-legal-document/index.vue").then(m => m.default || m)
  },
  {
    name: simulatorkt2BxS51gOMeta?.name ?? "simulator___de",
    path: simulatorkt2BxS51gOMeta?.path ?? "/de/simulator",
    meta: simulatorkt2BxS51gOMeta || {},
    alias: simulatorkt2BxS51gOMeta?.alias || [],
    redirect: simulatorkt2BxS51gOMeta?.redirect,
    component: () => import("/home/forge/app.getgreengold.com/pages/simulator.vue").then(m => m.default || m)
  },
  {
    name: simulatorkt2BxS51gOMeta?.name ?? "simulator___en",
    path: simulatorkt2BxS51gOMeta?.path ?? "/en/simulator",
    meta: simulatorkt2BxS51gOMeta || {},
    alias: simulatorkt2BxS51gOMeta?.alias || [],
    redirect: simulatorkt2BxS51gOMeta?.redirect,
    component: () => import("/home/forge/app.getgreengold.com/pages/simulator.vue").then(m => m.default || m)
  },
  {
    name: simulatorkt2BxS51gOMeta?.name ?? "simulator___fr",
    path: simulatorkt2BxS51gOMeta?.path ?? "/fr/simulator",
    meta: simulatorkt2BxS51gOMeta || {},
    alias: simulatorkt2BxS51gOMeta?.alias || [],
    redirect: simulatorkt2BxS51gOMeta?.redirect,
    component: () => import("/home/forge/app.getgreengold.com/pages/simulator.vue").then(m => m.default || m)
  },
  {
    name: simulatorkt2BxS51gOMeta?.name ?? "simulator___nl",
    path: simulatorkt2BxS51gOMeta?.path ?? "/nl/simulator",
    meta: simulatorkt2BxS51gOMeta || {},
    alias: simulatorkt2BxS51gOMeta?.alias || [],
    redirect: simulatorkt2BxS51gOMeta?.redirect,
    component: () => import("/home/forge/app.getgreengold.com/pages/simulator.vue").then(m => m.default || m)
  },
  {
    name: indexijbq3UOengMeta?.name ?? "support-tickets___de",
    path: indexijbq3UOengMeta?.path ?? "/de/support-tickets",
    meta: indexijbq3UOengMeta || {},
    alias: indexijbq3UOengMeta?.alias || [],
    redirect: indexijbq3UOengMeta?.redirect,
    component: () => import("/home/forge/app.getgreengold.com/pages/support-tickets/index.vue").then(m => m.default || m)
  },
  {
    name: indexijbq3UOengMeta?.name ?? "support-tickets___en",
    path: indexijbq3UOengMeta?.path ?? "/en/support-tickets",
    meta: indexijbq3UOengMeta || {},
    alias: indexijbq3UOengMeta?.alias || [],
    redirect: indexijbq3UOengMeta?.redirect,
    component: () => import("/home/forge/app.getgreengold.com/pages/support-tickets/index.vue").then(m => m.default || m)
  },
  {
    name: indexijbq3UOengMeta?.name ?? "support-tickets___fr",
    path: indexijbq3UOengMeta?.path ?? "/fr/support-tickets",
    meta: indexijbq3UOengMeta || {},
    alias: indexijbq3UOengMeta?.alias || [],
    redirect: indexijbq3UOengMeta?.redirect,
    component: () => import("/home/forge/app.getgreengold.com/pages/support-tickets/index.vue").then(m => m.default || m)
  },
  {
    name: indexijbq3UOengMeta?.name ?? "support-tickets___nl",
    path: indexijbq3UOengMeta?.path ?? "/nl/support-tickets",
    meta: indexijbq3UOengMeta || {},
    alias: indexijbq3UOengMeta?.alias || [],
    redirect: indexijbq3UOengMeta?.redirect,
    component: () => import("/home/forge/app.getgreengold.com/pages/support-tickets/index.vue").then(m => m.default || m)
  },
  {
    name: _91_91depotid_93_93HakVe2VTZHMeta?.name ?? "trading-buy-depotid___de",
    path: _91_91depotid_93_93HakVe2VTZHMeta?.path ?? "/de/trading/buy/:depotid?",
    meta: _91_91depotid_93_93HakVe2VTZHMeta || {},
    alias: _91_91depotid_93_93HakVe2VTZHMeta?.alias || [],
    redirect: _91_91depotid_93_93HakVe2VTZHMeta?.redirect,
    component: () => import("/home/forge/app.getgreengold.com/pages/trading/buy/[[depotid]].vue").then(m => m.default || m)
  },
  {
    name: _91_91depotid_93_93HakVe2VTZHMeta?.name ?? "trading-buy-depotid___en",
    path: _91_91depotid_93_93HakVe2VTZHMeta?.path ?? "/en/trading/buy/:depotid?",
    meta: _91_91depotid_93_93HakVe2VTZHMeta || {},
    alias: _91_91depotid_93_93HakVe2VTZHMeta?.alias || [],
    redirect: _91_91depotid_93_93HakVe2VTZHMeta?.redirect,
    component: () => import("/home/forge/app.getgreengold.com/pages/trading/buy/[[depotid]].vue").then(m => m.default || m)
  },
  {
    name: _91_91depotid_93_93HakVe2VTZHMeta?.name ?? "trading-buy-depotid___fr",
    path: _91_91depotid_93_93HakVe2VTZHMeta?.path ?? "/fr/trading/buy/:depotid?",
    meta: _91_91depotid_93_93HakVe2VTZHMeta || {},
    alias: _91_91depotid_93_93HakVe2VTZHMeta?.alias || [],
    redirect: _91_91depotid_93_93HakVe2VTZHMeta?.redirect,
    component: () => import("/home/forge/app.getgreengold.com/pages/trading/buy/[[depotid]].vue").then(m => m.default || m)
  },
  {
    name: _91_91depotid_93_93HakVe2VTZHMeta?.name ?? "trading-buy-depotid___nl",
    path: _91_91depotid_93_93HakVe2VTZHMeta?.path ?? "/nl/trading/buy/:depotid?",
    meta: _91_91depotid_93_93HakVe2VTZHMeta || {},
    alias: _91_91depotid_93_93HakVe2VTZHMeta?.alias || [],
    redirect: _91_91depotid_93_93HakVe2VTZHMeta?.redirect,
    component: () => import("/home/forge/app.getgreengold.com/pages/trading/buy/[[depotid]].vue").then(m => m.default || m)
  },
  {
    name: _91_91depotid_93_93pXhJQXF6zyMeta?.name ?? "trading-delivery-depotid___de",
    path: _91_91depotid_93_93pXhJQXF6zyMeta?.path ?? "/de/trading/delivery/:depotid?",
    meta: _91_91depotid_93_93pXhJQXF6zyMeta || {},
    alias: _91_91depotid_93_93pXhJQXF6zyMeta?.alias || [],
    redirect: _91_91depotid_93_93pXhJQXF6zyMeta?.redirect,
    component: () => import("/home/forge/app.getgreengold.com/pages/trading/delivery/[[depotid]].vue").then(m => m.default || m)
  },
  {
    name: _91_91depotid_93_93pXhJQXF6zyMeta?.name ?? "trading-delivery-depotid___en",
    path: _91_91depotid_93_93pXhJQXF6zyMeta?.path ?? "/en/trading/delivery/:depotid?",
    meta: _91_91depotid_93_93pXhJQXF6zyMeta || {},
    alias: _91_91depotid_93_93pXhJQXF6zyMeta?.alias || [],
    redirect: _91_91depotid_93_93pXhJQXF6zyMeta?.redirect,
    component: () => import("/home/forge/app.getgreengold.com/pages/trading/delivery/[[depotid]].vue").then(m => m.default || m)
  },
  {
    name: _91_91depotid_93_93pXhJQXF6zyMeta?.name ?? "trading-delivery-depotid___fr",
    path: _91_91depotid_93_93pXhJQXF6zyMeta?.path ?? "/fr/trading/delivery/:depotid?",
    meta: _91_91depotid_93_93pXhJQXF6zyMeta || {},
    alias: _91_91depotid_93_93pXhJQXF6zyMeta?.alias || [],
    redirect: _91_91depotid_93_93pXhJQXF6zyMeta?.redirect,
    component: () => import("/home/forge/app.getgreengold.com/pages/trading/delivery/[[depotid]].vue").then(m => m.default || m)
  },
  {
    name: _91_91depotid_93_93pXhJQXF6zyMeta?.name ?? "trading-delivery-depotid___nl",
    path: _91_91depotid_93_93pXhJQXF6zyMeta?.path ?? "/nl/trading/delivery/:depotid?",
    meta: _91_91depotid_93_93pXhJQXF6zyMeta || {},
    alias: _91_91depotid_93_93pXhJQXF6zyMeta?.alias || [],
    redirect: _91_91depotid_93_93pXhJQXF6zyMeta?.redirect,
    component: () => import("/home/forge/app.getgreengold.com/pages/trading/delivery/[[depotid]].vue").then(m => m.default || m)
  },
  {
    name: _91_91depotid_93_936rmo02NVtTMeta?.name ?? "trading-sell-depotid___de",
    path: _91_91depotid_93_936rmo02NVtTMeta?.path ?? "/de/trading/sell/:depotid?",
    meta: _91_91depotid_93_936rmo02NVtTMeta || {},
    alias: _91_91depotid_93_936rmo02NVtTMeta?.alias || [],
    redirect: _91_91depotid_93_936rmo02NVtTMeta?.redirect,
    component: () => import("/home/forge/app.getgreengold.com/pages/trading/sell/[[depotid]].vue").then(m => m.default || m)
  },
  {
    name: _91_91depotid_93_936rmo02NVtTMeta?.name ?? "trading-sell-depotid___en",
    path: _91_91depotid_93_936rmo02NVtTMeta?.path ?? "/en/trading/sell/:depotid?",
    meta: _91_91depotid_93_936rmo02NVtTMeta || {},
    alias: _91_91depotid_93_936rmo02NVtTMeta?.alias || [],
    redirect: _91_91depotid_93_936rmo02NVtTMeta?.redirect,
    component: () => import("/home/forge/app.getgreengold.com/pages/trading/sell/[[depotid]].vue").then(m => m.default || m)
  },
  {
    name: _91_91depotid_93_936rmo02NVtTMeta?.name ?? "trading-sell-depotid___fr",
    path: _91_91depotid_93_936rmo02NVtTMeta?.path ?? "/fr/trading/sell/:depotid?",
    meta: _91_91depotid_93_936rmo02NVtTMeta || {},
    alias: _91_91depotid_93_936rmo02NVtTMeta?.alias || [],
    redirect: _91_91depotid_93_936rmo02NVtTMeta?.redirect,
    component: () => import("/home/forge/app.getgreengold.com/pages/trading/sell/[[depotid]].vue").then(m => m.default || m)
  },
  {
    name: _91_91depotid_93_936rmo02NVtTMeta?.name ?? "trading-sell-depotid___nl",
    path: _91_91depotid_93_936rmo02NVtTMeta?.path ?? "/nl/trading/sell/:depotid?",
    meta: _91_91depotid_93_936rmo02NVtTMeta || {},
    alias: _91_91depotid_93_936rmo02NVtTMeta?.alias || [],
    redirect: _91_91depotid_93_936rmo02NVtTMeta?.redirect,
    component: () => import("/home/forge/app.getgreengold.com/pages/trading/sell/[[depotid]].vue").then(m => m.default || m)
  },
  {
    name: _91_91depotid_93_93GuSj10qM0eMeta?.name ?? "trading-transfer-depotid___de",
    path: _91_91depotid_93_93GuSj10qM0eMeta?.path ?? "/de/trading/transfer/:depotid?",
    meta: _91_91depotid_93_93GuSj10qM0eMeta || {},
    alias: _91_91depotid_93_93GuSj10qM0eMeta?.alias || [],
    redirect: _91_91depotid_93_93GuSj10qM0eMeta?.redirect,
    component: () => import("/home/forge/app.getgreengold.com/pages/trading/transfer/[[depotid]].vue").then(m => m.default || m)
  },
  {
    name: _91_91depotid_93_93GuSj10qM0eMeta?.name ?? "trading-transfer-depotid___en",
    path: _91_91depotid_93_93GuSj10qM0eMeta?.path ?? "/en/trading/transfer/:depotid?",
    meta: _91_91depotid_93_93GuSj10qM0eMeta || {},
    alias: _91_91depotid_93_93GuSj10qM0eMeta?.alias || [],
    redirect: _91_91depotid_93_93GuSj10qM0eMeta?.redirect,
    component: () => import("/home/forge/app.getgreengold.com/pages/trading/transfer/[[depotid]].vue").then(m => m.default || m)
  },
  {
    name: _91_91depotid_93_93GuSj10qM0eMeta?.name ?? "trading-transfer-depotid___fr",
    path: _91_91depotid_93_93GuSj10qM0eMeta?.path ?? "/fr/trading/transfer/:depotid?",
    meta: _91_91depotid_93_93GuSj10qM0eMeta || {},
    alias: _91_91depotid_93_93GuSj10qM0eMeta?.alias || [],
    redirect: _91_91depotid_93_93GuSj10qM0eMeta?.redirect,
    component: () => import("/home/forge/app.getgreengold.com/pages/trading/transfer/[[depotid]].vue").then(m => m.default || m)
  },
  {
    name: _91_91depotid_93_93GuSj10qM0eMeta?.name ?? "trading-transfer-depotid___nl",
    path: _91_91depotid_93_93GuSj10qM0eMeta?.path ?? "/nl/trading/transfer/:depotid?",
    meta: _91_91depotid_93_93GuSj10qM0eMeta || {},
    alias: _91_91depotid_93_93GuSj10qM0eMeta?.alias || [],
    redirect: _91_91depotid_93_93GuSj10qM0eMeta?.redirect,
    component: () => import("/home/forge/app.getgreengold.com/pages/trading/transfer/[[depotid]].vue").then(m => m.default || m)
  },
  {
    name: indexQ3Ema4vgzPMeta?.name ?? "upvest-account-history___de",
    path: indexQ3Ema4vgzPMeta?.path ?? "/de/upvest-account-history",
    meta: indexQ3Ema4vgzPMeta || {},
    alias: indexQ3Ema4vgzPMeta?.alias || [],
    redirect: indexQ3Ema4vgzPMeta?.redirect,
    component: () => import("/home/forge/app.getgreengold.com/pages/upvest-account-history/index.vue").then(m => m.default || m)
  },
  {
    name: indexQ3Ema4vgzPMeta?.name ?? "upvest-account-history___en",
    path: indexQ3Ema4vgzPMeta?.path ?? "/en/upvest-account-history",
    meta: indexQ3Ema4vgzPMeta || {},
    alias: indexQ3Ema4vgzPMeta?.alias || [],
    redirect: indexQ3Ema4vgzPMeta?.redirect,
    component: () => import("/home/forge/app.getgreengold.com/pages/upvest-account-history/index.vue").then(m => m.default || m)
  },
  {
    name: indexQ3Ema4vgzPMeta?.name ?? "upvest-account-history___fr",
    path: indexQ3Ema4vgzPMeta?.path ?? "/fr/upvest-account-history",
    meta: indexQ3Ema4vgzPMeta || {},
    alias: indexQ3Ema4vgzPMeta?.alias || [],
    redirect: indexQ3Ema4vgzPMeta?.redirect,
    component: () => import("/home/forge/app.getgreengold.com/pages/upvest-account-history/index.vue").then(m => m.default || m)
  },
  {
    name: indexQ3Ema4vgzPMeta?.name ?? "upvest-account-history___nl",
    path: indexQ3Ema4vgzPMeta?.path ?? "/nl/upvest-account-history",
    meta: indexQ3Ema4vgzPMeta || {},
    alias: indexQ3Ema4vgzPMeta?.alias || [],
    redirect: indexQ3Ema4vgzPMeta?.redirect,
    component: () => import("/home/forge/app.getgreengold.com/pages/upvest-account-history/index.vue").then(m => m.default || m)
  },
  {
    name: indexKHN78DaWjwMeta?.name ?? "upvest-activate___de",
    path: indexKHN78DaWjwMeta?.path ?? "/de/upvest-activate",
    meta: indexKHN78DaWjwMeta || {},
    alias: indexKHN78DaWjwMeta?.alias || [],
    redirect: indexKHN78DaWjwMeta?.redirect,
    component: () => import("/home/forge/app.getgreengold.com/pages/upvest-activate/index.vue").then(m => m.default || m)
  },
  {
    name: indexKHN78DaWjwMeta?.name ?? "upvest-activate___en",
    path: indexKHN78DaWjwMeta?.path ?? "/en/upvest-activate",
    meta: indexKHN78DaWjwMeta || {},
    alias: indexKHN78DaWjwMeta?.alias || [],
    redirect: indexKHN78DaWjwMeta?.redirect,
    component: () => import("/home/forge/app.getgreengold.com/pages/upvest-activate/index.vue").then(m => m.default || m)
  },
  {
    name: indexKHN78DaWjwMeta?.name ?? "upvest-activate___fr",
    path: indexKHN78DaWjwMeta?.path ?? "/fr/upvest-activate",
    meta: indexKHN78DaWjwMeta || {},
    alias: indexKHN78DaWjwMeta?.alias || [],
    redirect: indexKHN78DaWjwMeta?.redirect,
    component: () => import("/home/forge/app.getgreengold.com/pages/upvest-activate/index.vue").then(m => m.default || m)
  },
  {
    name: indexKHN78DaWjwMeta?.name ?? "upvest-activate___nl",
    path: indexKHN78DaWjwMeta?.path ?? "/nl/upvest-activate",
    meta: indexKHN78DaWjwMeta || {},
    alias: indexKHN78DaWjwMeta?.alias || [],
    redirect: indexKHN78DaWjwMeta?.redirect,
    component: () => import("/home/forge/app.getgreengold.com/pages/upvest-activate/index.vue").then(m => m.default || m)
  }
]